import React, { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import {
  Alert,
  Badge,
  Button,
  EmptyState,
  Page,
  PageHeader,
  PageLoader,
  Panel,
  SectionHeading,
} from "../components/ui";

/** One priced solution: its artwork, its name and code, and what it costs. */
const SolutionCard = ({ item }) => (
  <div className="flex items-center gap-4 rounded-[16px] border border-gray-200 bg-white p-3 transition hover:border-red-300 dark:border-[#3a3a3d]/70 dark:bg-[#262628] dark:hover:border-orange-400/40">
    <img
      src={item.image_url}
      alt={item.name}
      className="h-20 w-20 shrink-0 rounded-[12px] object-cover"
    />
    <div className="min-w-0 flex-1">
      <h3 className="truncate text-sm font-bold text-gray-900 dark:text-white" title={item.name}>
        {item.name}
      </h3>
      <p className="truncate text-xs text-gray-500 dark:text-slate-400" title={item.code}>
        {item.code}
      </p>
      <span className="mt-2 inline-flex rounded-full bg-gradient-to-r from-red-600 to-orange-500 px-2.5 py-1 text-xs font-bold text-white">
        {item.credits} CRS
      </span>
    </div>
  </div>
);

const PriceList = () => {
  const [solutions, setSolutions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get("/solutions")
      .then((response) => {
        setLoading(false);
        setSolutions(response.data);
      })
      .catch((error) => {
        console.error("Error fetching solutions:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Page>
        <PageHeader title="Price List" onBack={() => window.history.back()} />
        <PageLoader label="Loading the price list…" />
      </Page>
    );
  }

  const groupedSolutions = solutions.reduce((acc, item) => {
    acc[item.type] = acc[item.type] || [];
    acc[item.type].push(item);
    return acc;
  }, {});

  const groups = Object.entries(groupedSolutions);

  return (
    <Page>
      <PageHeader title="Price List" subtitle="1 CRS = 1 EUR" onBack={() => window.history.back()}>
        <Button to="/buy-credits">Buy Credits</Button>
      </PageHeader>

      <Alert tone="info">
        Most of our solutions are thoroughly tested before being shared. We work hard to ensure the
        best experience for our customers and fully support our files until the job is successfully
        completed. For assistance, you can always open a ticket — one of our admins is online and
        ready to help.
      </Alert>

      {groups.length === 0 ? (
        <EmptyState title="No solutions published yet" hint="Check back shortly." />
      ) : (
        groups.map(([type, items]) => (
          <Panel key={type}>
            <SectionHeading title={type} badge={<Badge>{items.length}</Badge>} />
            <div className="mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
              {items.map((item) => (
                <SolutionCard key={item.id} item={item} />
              ))}
            </div>
          </Panel>
        ))
      )}
    </Page>
  );
};

export default PriceList;
